<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="add-term-wrapper"
      :title="title"
      :width="width"
      :hasHeaderRightIcon="false"
    >
      <template>
        <div class="padding-16" v-if="visible">
          <AttachmentTempUploader
            :label="$lang.upload_file"
            :hasEditTitle="true"
            :uploaderName="uploaderName"
            :currentFiles="currentFiles"
            @getFiles="getTempFiles"
            @remove="removeFile"
          />
        </div>
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleClose"
        />
        <Button
          :disabled="
            !checkPermission(permissions, ['admin', 'edit']) ||
            !tempFiles.length
          "
          variant="primary"
          :text="$lang.submit"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          :loading="loading"
          @click="handleSubmit"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import { LeftSidebar, AttachmentTempUploader } from "@/components/re-design";
import { Button } from "@/components/re-design/forms";
import { checkPermission, generateError } from "@/shared/utils";
import { inject, ref, toRefs } from "vue";

export default {
  components: { LeftSidebar, AttachmentTempUploader, Button },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    submitMethod: {
      type: Function,
      default: () => {},
    },
    uploaderName: {
      type: String,
      default: "",
    },
    currentFiles: {
      type: Array,
      default: () => [],
    },
    width: {
      type: [String, Number],
      default: null,
    },
  },
  setup(props, { emit }) {
    // bind props
    const { visible, title, uploaderName } = toRefs(props);

    // inject data
    const permissions = inject("permissions");

    // parent emits
    const handleClose = () => emit("handleClose");
    const handleReload = () => emit("handleReload");

    let tempFiles = ref([]);
    const getTempFiles = (files) => (tempFiles.value = files);
    const removeFile = (removeCode) => {
      const index = tempFiles.value.findIndex(
        ({ clientCode }) => clientCode === removeCode
      );
      if (index !== -1) {
        tempFiles.value.splice(index, 1);
      }
    };

    const loading = ref(false);
    const handleSubmit = async () => {
      try {
        loading.value = true;
        // remove clientCode of payload
        const payload = tempFiles.value.map((item) => {
          const { clientCode, ...otherData } = item;
          return {
            ...otherData,
          };
        });

        await props.submitMethod(payload);
        handleClose();
        handleReload();
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };

    // return data to be used in template
    return {
      visible,
      permissions,
      title,
      uploaderName,
      checkPermission,
      getTempFiles,
      removeFile,
      loading,
      handleClose,
      handleSubmit,
      tempFiles,
    };
  },
};
</script>
